import gql from 'graphql-tag'

const exportEmail = gql`mutation sendUserEmailRoles($email: String){
    sendUserEmailRoles(email: $email){
        internalCode
        message
    }
}
`
// console.log();
// const ExportUsersEmail = ({ children, ...props }) => {
//   return (
//     <MutationManager mutation={exportEmail} refetchQueries={[]}>
//       {({ data, loading }) =>
//         children({
//           data,
//           loading,
//           ...props
//         })}
//     </MutationManager>
//   )
// }

// ExportUsersEmail.propTypes = {
//   children: PropTypes.any
// }

export default exportEmail;